import Registration from 'components/Pages/Registration/Registration';

export default Registration;
